import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AutoCompleteControl } from '../../../form-models/autocomplete-control';

@Component({
  selector: 'hb-dynamic-auto-complete',
  templateUrl: './dynamic-auto-complete.component.html',
})
export class DynamicAutoCompleteComponent {
  _control: AutoCompleteControl;
  filteredOptions: any[];

  @Input() formGroup: FormGroup;
  @Input() set control(control: AutoCompleteControl) {
    this._control = control;
    this.filteredOptions = control.options && control.options.length > 0 ? control.options.map(x => x.label) : [];
  }

  @Output() onOverrideValue = new EventEmitter();

  get control(): AutoCompleteControl {
    return this._control;
  }

  constructor() {}

  filterOptions(event) {
    if (!this.control || !this.control.options) {
      this.filteredOptions = [];
    }
    this.filteredOptions = this.control.options.filter(x => x.label.toLowerCase().indexOf(event.query.toLowerCase()) === 0).map(x => x.label);
  }

  public overrideValue() {
    this.onOverrideValue.emit();
  }
}
